<div class="container">
    <div class="icon-logo-color">
        <mat-icon>
            <img src="assets/icons/pn-logo-color.svg"/>
        </mat-icon>
    </div>
    <h2 class="title">Registration link has expired</h2>
    <div class="description">
        <p>
            Your registration link has expired. <br>
            PatientNow registration links expire every 72 hours and can be only used once. 
        </p>
        <p>Please contact your administration to send another link.</p>
    </div>
</div>